// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Input } from '@angular/core';

@Component({
    selector: 'three-dot-loader',
    templateUrl: './three-dot-loader.component.html',
    styleUrls: ['./three-dot-loader.component.scss'],
})
export class ThreeDotLoaderComponent {
    @Input() isTopAligned = false;
    constructor() {}
}
